/**
 * @param start
 * @param end
 * @param step
 */
export default function (start, end, step = 1) {
  const len = Math.floor((end - start) / step) + 1
  return Array(len)
    .fill()
    .map((_, idx) => start + idx * step)
}
